/* eslint-disable no-case-declarations */
import { MaplibreLayer } from "mobility-toolbox-js/ol";
import { defaults } from "ol/interaction";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import VectorLayer from "ol/layer/Vector";
import Map from "ol/Map";
import VectorSource from "ol/source/Vector";
import View from "ol/View";

// import { buffer } from "ol/extent";
import config from "../config";
import {
  DEBUG_MODE_DEFAULT,
  DEBUG_MODE_SBM,
  DEBUG_MODES,
  LocaleStorageKey,
  LS_ALL_SITUATIONS_OPEN_KEY,
  LS_BOOKMARKS_KEY,
} from "../constants";
import { TralisMode } from "../constants";
import LocalStorage from "../LocalStorage";
import { getNotificationsWithStatus } from "../utils";

import {
  CLEAR_DEPARTURES,
  CLEAR_GEOFOX_DEPARTURES,
  SET_ARE_SITUATIONS_OPEN,
  SET_BACKGROUND_LAYER,
  SET_BOOKMARKS,
  SET_BOOKMARKS_POPUP,
  SET_DEBUG_MODE,
  SET_DEPARTURES_LOADING,
  SET_GEOFOX_DEPARTURES_LOADING,
  SET_HIDDEN_DISRUPTIONS,
  SET_HIGHLIGHT_STATION,
  SET_INCIDENT_PROGRAM,
  SET_IS_FOLLOWING_VEHICLE,
  SET_IS_FOLLOWING_VEHICLE_LOADING,
  SET_IS_MOTS_RELATION_OPENED,
  SET_IS_ROUTE_INFO_OPENED,
  SET_MAP,
  SET_MODE,
  SET_NOTIFICATIONS,
  SET_NOTIFICATIONS_ICONS_LAYER,
  SET_NOTIFICATIONS_LAYER,
  SET_NOTIFICATIONS_LOADING,
  SET_PREVIEW_NOTIFICATION,
  SET_PREVIEW_SITUATIONS,
  SET_REALTIME_LAYER,
  SET_RIS_POPUP,
  SET_SCHEMATIC_BG_LAYER,
  SET_SELECTED_LINE,
  SET_SELECTED_NOTIFICATIONS_BY_ID,
  SET_SELECTED_VEHICLE,
  SET_SITUATIONS,
  SET_STATION,
  SET_STATION_ICONS_LEGEND_POPUP,
  SET_STOP_SEQUENCE,
  SET_STOP_SEQUENCES,
  SET_TOPOGRAPHIC_BG_LAYER,
  SET_VISIBLE_STATIONS,
  UPDATE_BUS_TRAJECTORIES,
  UPDATE_EXTRA_GEOMS,
  UPDATE_LINE_IN_LINES,
  UPDATE_STATION_IN_STATIONS,
  UPSERT_DEPARTURES,
  UPSERT_DISRUPTIONS,
  UPSERT_GEOFOX_DEPARTURES,
  UPSERT_STATIONS,
} from "./actions";

import type { MocoLayer } from "mobility-toolbox-js/ol";
import type { MaplibreStyleLayer } from "mobility-toolbox-js/ol";
import type { PublicationType, SituationType } from "mobility-toolbox-js/types";
import type {
  RealtimeDeparture,
  RealtimeLine,
  RealtimeStationproperties,
  RealtimeStopSequence,
  RealtimeTrajectoryProperties,
} from "mobility-toolbox-js/types";
import type { Feature } from "ol";
import type { GeoJSONGeometry } from "ol/format/GeoJSON";
import type { Geometry } from "ol/geom";

import type { Config } from "../configs/common";
import type { TralisMode as TralisModeType } from "../constants";
import type TralisLayer from "../TralisLayer";

import type { AppAction } from "./store";

const testDisruptions = [
  {
    content:
      "Aus betrieblichen Gründen entfallen heute Nachmittag folgende S-Bahnen des 10-Minuten-Takts auf der Linie S 8:<br><br>S 8 München Ost Abfahrt 16:47 Uhr - Germering-Unterpfaffenhofen Ankunft 17:17 Uhr<br>S 8 München Ost Abfahrt 18:27 Uhr - Gilching-Argelsried Ankunft 19:05 Uhr<br><br>S 8 Germering-Unterpfaffenhofen Abfahrt 17:21 Uhr - München Ost Ankunft 17:54 Uhr<br><br>Bitte beachten Sie, dass es heute Nachmittag auf der Linie S 8 zu weiteren Ausfällen der S-Bahnen des 10-Minuten-Takts kommen kann.",
    lines: [
      {
        color: "#000000",
        id: 8,
        name: "S8",
        stroke: "#fbc606",
        text_color: "#fbc606",
      },
    ],
    title: "Ausfälle des 10-Minuten-Takts auf der Linie S 8",
    updated: "2020-07-27T14:17:35+02:00",
  },
  {
    content:
      "Aus betrieblichen Gründen entfallen heute Nachmittag folgende S-Bahnen des 10-Minuten-Takts auf der Linie S 8:<br><br>S 8 München Ost Abfahrt 16:47 Uhr - Germering-Unterpfaffenhofen Ankunft 17:17 Uhr<br>S 8 München Ost Abfahrt 18:27 Uhr - Gilching-Argelsried Ankunft 19:05 Uhr<br><br>S 8 Germering-Unterpfaffenhofen Abfahrt 17:21 Uhr - München Ost Ankunft 17:54 Uhr<br><br>Bitte beachten Sie, dass es heute Nachmittag auf der Linie S 8 zu weiteren Ausfällen der S-Bahnen des 10-Minuten-Takts kommen kann.",
    lines: [],
    title: "Ausfälle des 10-Minuten-Takts",
    updated: "2020-07-27T14:17:35+02:00",
  },
];

const params =
  Object.fromEntries(new URLSearchParams(window.location.search)) || {};

// Defines the debug mode from the permalink.
let debugMode: boolean | string = false;
let isDebug = false;
if (DEBUG_MODES.includes(params.debug)) {
  debugMode = params.debug;
  isDebug = true;
}

const localStorage = new LocalStorage(config.localStorageKey);
const bookmarks = localStorage.getItem(LS_BOOKMARKS_KEY);
const storedAllSituationsOpen = localStorage.getItem(
  LS_ALL_SITUATIONS_OPEN_KEY,
);
const mode: TralisModeType = Object.values(TralisMode).includes(
  params.mode as TralisModeType,
)
  ? (params.mode as TralisModeType)
  : TralisMode.Schematic;
const configMode = config[mode];
const x = parseFloat(params.x) || configMode.x;
const y = parseFloat(params.y) || configMode.y;
const z = parseFloat(params.z) || configMode.z;
// const extent = config[mode].dataExtent;
const minZoom = isDebug ? 0 : config[mode].minZoom;
const maxZoom = isDebug ? 100 : config[mode].maxZoom;
const isSchematic = params.mode === TralisMode.Schematic;
const isTopographic = params.mode === TralisMode.Topographic;
const topographic = config.topographic;
const schematic = config.schematic;
const { notificationat } = params;

export interface Bookmark {
  item: {
    path: string;
    title: string;
  };
}
export type PreviewNotification = Record<
  string,
  {
    graphs: Record<string, Notification>;
    id: string;
  }
>;
export interface Notification {
  [key: string]: unknown;
  properties: {
    id: string;

    isActive: boolean;
  };
}
export interface SituationPublicationGeometry {
  geom?: GeoJSONGeometry;
}
export interface SituationPublicationLine {
  geometry?: SituationPublicationGeometry[];
}
export interface SituationPublicationLineGroup {
  lines?: SituationPublicationLine[];
}
export interface SituationPublicationStop {
  geometry?: SituationPublicationGeometry[];
}
export interface SituationPublicationTextualContent {
  description?: string;
  summary?: string;
}
export type SituationPublication = {
  publicationLineNames?: string[];
} & PublicationType;
export type Situation = {
  publications?: SituationPublication[];
} & Omit<SituationType, "publications">;

export interface AppState {
  activeNotifications: unknown[];
  areSituationsOpen?: boolean;
  auto: boolean;
  backgroundLayer?: MaplibreLayer | null;
  bookmarks: Bookmark[];
  bookmarksPopup: boolean;
  busTrajectories: unknown[];
  config: Config;
  debug: boolean | string;
  departures: unknown[];
  departuresLoading: boolean;
  disruptions: unknown[];
  extraLayerTags: unknown[];
  geofoxDepartures?: Record<string, unknown>;
  geofoxDeparturesLoading?: boolean;
  hiddenDisruptions: unknown[];
  hideOthers: boolean;
  highlightStation: Feature<Geometry, RealtimeStationproperties> | null;
  incidentProgram?: unknown;
  initialStationLoading?: boolean;
  isDefaultDebug: boolean;
  isFollowingVehicle: boolean;
  isFollowingVehicleLoading: boolean;
  isMotsRelationOpened: boolean;
  isRouteInfoOpened: boolean;
  isSbmDebug: boolean;
  line: null | string;
  lines: RealtimeLine[];
  localStorage: LocalStorage;
  map: Map;
  mode: TralisModeType;
  noDisruption: boolean;
  noRouteInfo: boolean;
  notifications: unknown[];
  notificationsIconsLayer?: MaplibreStyleLayer | null;
  notificationsLayer: MocoLayer | null;
  notificationsLoading?: boolean;
  previewNotification?: PreviewNotification;
  previewSituations?: Situation[];
  realtimeLayer?: null | TralisLayer;
  risPopup: boolean;
  schematicBgLayer: MaplibreLayer;
  selectedLine?: null | RealtimeLine;
  selectedLines: RealtimeLine[];
  selectedNotificationIds: string[];
  selectedNotifications: Notification[];
  selectedVehicles: RealtimeTrajectoryProperties[];
  situations?: Situation[];
  station: Feature<Geometry, RealtimeStationproperties> | null;
  stationIconsLegendPopup: boolean;
  stations: unknown[];
  stationsIds?: unknown[];
  stationsLayer: VectorLayer;
  stopSequence?: null | RealtimeStopSequence;
  stopSequences?: RealtimeStopSequence[];
  topographicBgLayer?: MaplibreLayer | null;
  train: null | string;
  trainAuto: boolean;
  visibleStations: Feature<Geometry, RealtimeStationproperties>[];
}

// We export for tests
export const initialState: AppState = {
  activeNotifications: [],
  areSituationsOpen:
    storedAllSituationsOpen === null
      ? true
      : storedAllSituationsOpen === "true",
  auto: params.auto === "true",
  bookmarks: bookmarks ? JSON.parse(bookmarks) : [],
  bookmarksPopup: false,
  busTrajectories: [],
  config,
  // From url parameters
  debug: debugMode,
  departures: [],
  departuresLoading: false,
  disruptions: params.disruptions === "true" ? testDisruptions : [],
  extraLayerTags: [],
  hiddenDisruptions: [],
  hideOthers: params.hideothers === "true",
  highlightStation: null,
  isDefaultDebug: debugMode === DEBUG_MODE_DEFAULT,
  isFollowingVehicle: false,
  isFollowingVehicleLoading: false,
  isMotsRelationOpened: false,
  isRouteInfoOpened: false,
  isSbmDebug: debugMode === DEBUG_MODE_SBM,
  line: config.lineParam ? params.line : null,
  lines: [],
  localStorage: localStorage,
  // Map and Layers
  map: new Map({
    controls: [],
    interactions:
      !isDebug && !config.userInteractions
        ? []
        : defaults({ pinchRotate: false }),
    moveTolerance: 5,
    view: new View({
      center: [x, y],
      maxZoom,
      // TODO it could be nice to set the extent but we can't set again when mode changes"
      // extent: buffer(extent, extent[2] - extent[0]),
      minZoom,
      zoom: z,
    }),
  }),
  mode,
  noDisruption: params.disruption === "false",
  noRouteInfo: params.routeinfo === "false",
  notifications: [],
  notificationsLayer: null,
  risPopup: false,
  schematicBgLayer: new MaplibreLayer({
    // @ts-expect-error - Find if it breaks something if it is a string
    key: 2,
    mapOptions: {
      maxCanvasSize: [Infinity, Infinity],
    },
    url: schematic.styleUrl,
    visible: isSchematic,
  }),
  selectedLines: [],
  selectedNotificationIds: [],
  selectedNotifications: [],

  selectedVehicles: [],
  station: null,
  stationIconsLegendPopup: false,
  stations: [],
  stationsLayer: new VectorLayer({
    source: new VectorSource(),
    zIndex: 1,
  }),
  topographicBgLayer: topographic.styleUrl
    ? new MaplibreLayer({
        // @ts-expect-error - Find if it breaks something if it is a string
        key: 1,
        mapOptions: {
          maxCanvasSize: [Infinity, Infinity],
        },
        url: topographic.styleUrl,
        visible: isTopographic,
      })
    : null,
  train: config.trainParam ? params.train : null,
  trainAuto: config.trainParam && /auto/i.test(params.train),
  visibleStations: [],
};

export default function tralisApp(
  state: AppState = initialState,
  action: AppAction,
): AppState {
  switch (action.type) {
    case CLEAR_DEPARTURES:
      return {
        ...state,
        departures: action.data as RealtimeDeparture[],
      };
    case CLEAR_GEOFOX_DEPARTURES:
      return {
        ...state,
        geofoxDepartures: action.data as Record<string, unknown>,
      };
    case SET_ARE_SITUATIONS_OPEN:
      return {
        ...state,
        areSituationsOpen: action.data as boolean,
        // Clean selected situations on close
        selectedNotificationIds: !action.data
          ? []
          : state.selectedNotificationIds,
      };
    case SET_BACKGROUND_LAYER:
      return {
        ...state,
        backgroundLayer: action.data as MaplibreLayer,
      };
    case SET_BOOKMARKS:
      const data = action.data as Bookmark[];
      const newBookmarks = data.length > 9 ? data.slice(0, 10) : data;
      localStorage.setItem(
        LocaleStorageKey.Bookmarks,
        JSON.stringify(newBookmarks),
      );
      return {
        ...state,
        bookmarks: newBookmarks,
      };
    case SET_BOOKMARKS_POPUP:
      return {
        ...state,
        bookmarksPopup: action.data as boolean,
      };
    case SET_DEBUG_MODE:
      return {
        ...state,
        debug: action.data as boolean,
        isDefaultDebug: action.data === DEBUG_MODE_DEFAULT,
        isSbmDebug: action.data === DEBUG_MODE_SBM,
      };
    case SET_DEPARTURES_LOADING:
      return {
        ...state,
        departuresLoading: action.data as boolean,
      };
    case SET_GEOFOX_DEPARTURES_LOADING:
      return {
        ...state,
        geofoxDeparturesLoading: action.data as boolean,
      };
    case SET_HIDDEN_DISRUPTIONS:
      return {
        ...state,
        hiddenDisruptions: action.data as unknown[],
      };
    case SET_HIGHLIGHT_STATION:
      return {
        ...state,
        highlightStation: action.data as Feature<
          Geometry,
          RealtimeStationproperties
        > | null,
      };
    case SET_INCIDENT_PROGRAM:
      return {
        ...state,
        incidentProgram: action.data,
      };
    case SET_IS_FOLLOWING_VEHICLE:
      return {
        ...state,
        isFollowingVehicle: action.data as boolean,
      };
    case SET_IS_FOLLOWING_VEHICLE_LOADING:
      return {
        ...state,
        isFollowingVehicleLoading: action.data as boolean,
      };
    case SET_IS_MOTS_RELATION_OPENED:
      return {
        ...state,
        isMotsRelationOpened: action.data as boolean,
      };
    case SET_IS_ROUTE_INFO_OPENED:
      return {
        ...state,
        isRouteInfoOpened: action.data as boolean,
      };
    case SET_MAP:
      return {
        ...state,
        map: action.data as Map,
      };
    case SET_MODE:
      return {
        ...state,
        mode: action.data as TralisModeType,
      };
    case SET_NOTIFICATIONS: {
      const notifications = (action.data as Notification[]).slice(0);
      const now = notificationat ? new Date(notificationat) : new Date();
      const graph =
        state.mode === TralisMode.Schematic ? "tralis_schematic_sbm" : "osm";
      const style: string =
        config[state.mode]?.style || "tralis_munich_schematic_v3";

      if (state.previewNotification?.[style]?.graphs[graph]) {
        const index = notifications.findIndex(
          (n) =>
            n.properties.id ===
            state.previewNotification?.[state.mode as string].id,
        );
        if (index > -1) {
          notifications[index] = state.previewNotification[style].graphs[graph];
        } else {
          notifications.push(state.previewNotification[style].graphs[graph]);
        }
      }
      const notificationsWithStatus: Notification[] =
        getNotificationsWithStatus(notifications, now) as Notification[];

      return {
        ...state,
        activeNotifications: notificationsWithStatus.filter(
          (notification) => notification.properties.isActive,
        ),
        notifications: notificationsWithStatus,
        selectedNotifications: notificationsWithStatus.filter((n) =>
          state.selectedNotifications
            .map((sn) => sn.properties.id)
            .includes(n.properties.id),
        ),
      };
    }
    case SET_NOTIFICATIONS_ICONS_LAYER:
      return {
        ...state,
        notificationsIconsLayer: action.data as MaplibreStyleLayer,
      };
    case SET_NOTIFICATIONS_LAYER:
      return {
        ...state,
        notificationsLayer: action.data as MocoLayer,
      };
    case SET_NOTIFICATIONS_LOADING:
      return {
        ...state,
        notificationsLoading: action.data as boolean,
      };
    case SET_PREVIEW_NOTIFICATION: {
      const notifications = (state.notifications as Notification[]).slice(0);
      const now = notificationat ? new Date(notificationat) : new Date();
      const graph =
        state.mode === TralisMode.Schematic ? "tralis_schematic_sbm" : "osm";
      const style: string =
        config[state.mode]?.style || "tralis_munich_schematic_v3";
      if ((action.data as PreviewNotification)?.[style]?.graphs[graph]) {
        const index = notifications.findIndex(
          (n) =>
            n.properties.id === (action.data as PreviewNotification)[style].id,
        );

        if (index > -1) {
          notifications[index] = (action.data as PreviewNotification)[
            style
          ].graphs[graph];
        } else {
          notifications.push(
            (action.data as PreviewNotification)[style].graphs[graph],
          );
        }
      }

      return {
        ...state,
        notifications: getNotificationsWithStatus(notifications, now),
        previewNotification: action.data as PreviewNotification,
        selectedNotifications: notifications.filter((n) =>
          state.selectedNotifications
            .map((sn) => sn.properties.id)
            .includes(n.properties.id),
        ),
      };
    }
    case SET_PREVIEW_SITUATIONS:
      return {
        ...state,
        previewSituations: action.data as Situation[],
      };
    case SET_REALTIME_LAYER:
      return {
        ...state,
        realtimeLayer: action.data as TralisLayer,
      };
    case SET_RIS_POPUP:
      return {
        ...state,
        risPopup: action.data as boolean,
      };
    case SET_SCHEMATIC_BG_LAYER:
      return {
        ...state,
        schematicBgLayer: action.data as MaplibreLayer,
      };
    case SET_SELECTED_LINE:
      return {
        ...state,
        selectedLine: action.data as RealtimeLine,
      };
    case SET_SELECTED_NOTIFICATIONS_BY_ID: {
      const selectedNotificationIds = action.data as string[];
      // Reopen the situations panel if a notification was clicked and it is currently closed.
      const shouldForceOpen =
        !!selectedNotificationIds.length && !state.areSituationsOpen;
      if (shouldForceOpen) {
        localStorage.setItem(LS_ALL_SITUATIONS_OPEN_KEY, String(true));
      }
      return {
        ...state,
        areSituationsOpen: shouldForceOpen ? true : state.areSituationsOpen,
        selectedNotificationIds,
      };
    }
    case SET_SELECTED_VEHICLE: {
      if (state.noRouteInfo) {
        return {
          ...state,
          isRouteInfoOpened: false,
          selectedVehicles: [],
        };
      }
      const selectedVehicles =
        (action.data as RealtimeTrajectoryProperties[]) || [];
      return {
        ...state,
        isRouteInfoOpened: selectedVehicles.length === 1,
        selectedVehicles,
      };
    }
    case SET_SITUATIONS:
      return {
        ...state,
        situations: action.data as Situation[],
      };
    case SET_STATION: {
      const stationData = action.data as {
        isStationLoadedFromPermalink: boolean;
        station: Feature<Geometry, RealtimeStationproperties>;
      };
      return {
        ...state,
        initialStationLoading: stationData.isStationLoadedFromPermalink,
        station: stationData.station,
      };
    }
    case SET_STATION_ICONS_LEGEND_POPUP:
      return {
        ...state,
        stationIconsLegendPopup: action.data as boolean,
      };
    case SET_STOP_SEQUENCE:
      return {
        ...state,
        stopSequence: action.data as RealtimeStopSequence,
      };
    case SET_STOP_SEQUENCES: {
      const previousStopSequence = state.stopSequence;
      let stopSequence = (action.data as RealtimeStopSequence[])?.[0];

      if (previousStopSequence && stopSequence) {
        stopSequence =
          (action.data as RealtimeStopSequence[]).find(
            (stopSeq) =>
              stopSeq.routeIdentifier === previousStopSequence.routeIdentifier,
          ) ?? (action.data as RealtimeStopSequence[])[0];
      }

      return {
        ...state,
        stopSequence,
        stopSequences: action.data as RealtimeStopSequence[] | undefined,
      };
    }
    case SET_TOPOGRAPHIC_BG_LAYER:
      return {
        ...state,
        topographicBgLayer: action.data as MaplibreLayer | null,
      };
    case SET_VISIBLE_STATIONS:
      return {
        ...state,
        visibleStations: action.data as Feature<
          Geometry,
          RealtimeStationproperties
        >[],
      };
    case UPDATE_BUS_TRAJECTORIES:
      return {
        ...state,
        busTrajectories: [...(action.data as unknown[])],
      };
    case UPDATE_EXTRA_GEOMS:
      return {
        ...state,
        extraLayerTags: [...(action.data as unknown[])],
      };
    case UPDATE_LINE_IN_LINES: {
      if (!action.data) {
        return state;
      }

      const lineToUpdate = action.data as RealtimeLine;

      const { lines } = state;

      const idx2 = lines.findIndex((line) => line.id === lineToUpdate.id);
      if (idx2 > -1) {
        lines[idx2] = lineToUpdate;
      } else {
        lines.push(lineToUpdate);
      }
      return {
        ...state,
        lines: [...lines],
      };
    }
    case UPDATE_STATION_IN_STATIONS: {
      if (!action.data) {
        return state;
      }

      const stationsToUpdate = action.data as Feature<
        Geometry,
        RealtimeStationproperties
      >[];

      const stations = state.stations as Feature<
        Geometry,
        RealtimeStationproperties
      >[];

      stationsToUpdate.forEach((stationToUpdate) => {
        const idx = stations.findIndex(
          (station) => station.get("uic") === stationToUpdate.get("uic"),
        );
        if (idx > -1) {
          stations[idx] = stationToUpdate;
        } else {
          stations.push(stationToUpdate);
        }
      });
      return {
        ...state,
        stations: [...stations],
        stationsIds: stations.map((station) => station.get("uic") as unknown),
      };
    }
    case UPSERT_DEPARTURES:
      return {
        ...state,
        departures: [...(action.data as unknown[])],
      };
    case UPSERT_DISRUPTIONS: {
      if (state.noDisruption) {
        return {
          ...state,
          disruptions: [],
        };
      }
      const disruptionsData = action.data as undefined | unknown[];
      if (
        params.disruptions === "true" &&
        disruptionsData &&
        !disruptionsData.length
      ) {
        return {
          ...state,
          disruptions: testDisruptions,
        };
      }
      return {
        ...state,
        disruptions: disruptionsData?.slice(0) ?? [],
      };
    }
    case UPSERT_GEOFOX_DEPARTURES:
      return {
        ...state,
        geofoxDepartures: { ...(action.data as Record<string, unknown>) },
      };
    case UPSERT_STATIONS: {
      const upsertedStations = action.data as Feature<
        Geometry,
        RealtimeStationproperties
      >[];
      return {
        ...state,
        stations: upsertedStations,
        stationsIds: (upsertedStations || []).map(
          (station) => station.get("uic") as unknown,
        ),
      };
    }
    default:
      break;
  }

  return { ...state };
}
